import React, {Component} from "react";
import {connect} from "react-redux";
import {CLUSTERS_COLORS_MAP} from "./../../helpers/colors";
import SVGIcon from "../svg/SVGIcon";

import "./RegionHeading.css";

class RegionHeading extends Component {

  render() {
    const {nuts3, cluster, country, metro} = this.props;
    const subtitle = nuts3 === metro ? `${cluster}, ${country}` : `${cluster}, ${metro}, ${country}`;
    return (
      <div className="fow-region-heading">
        <span className="fow-region-heading-icon" style={{backgroundColor: CLUSTERS_COLORS_MAP[cluster]}}><SVGIcon name="stars" /></span>
        <div className="fow-region-heading-text">
          <div className="fow-region-heading-title fow-font-title fow-font-size-xl">{nuts3}</div>
          <div className="fow-region-heading-subtitle fow-font-text fow-font-size-sm">{subtitle}</div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
  };
};
const mapDispatchToProps = dispatch => ({
});


export default connect(mapStateToProps, mapDispatchToProps)(RegionHeading);
